<template>
  <div class="right">
    <div class="steps">
      <a>
        <img
          src="../assets/img/about/home.png"
          class="home"
          @click="backToHome"
        />
      </a>
      <p>首页</p>
      <img src="../assets/img/about/arrow.png" class="arrow" />
      <p>{{ bread[0] }}</p>
      <img src="../assets/img/about/arrow.png" class="arrow" />
      <p class="blue">{{ bread[1] }}</p>
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "SideNavContent",
  props: {
    nowActive: Number,
    bread: Array
  },
  created() {
    console.log(this.$props);
  },
  methods: {
    backToHome() {
      this.$store.commit("updateMenuItem", { title: "首页", path: "/index" });
      this.$router.push("/index");
    }
  }
};
</script>

<style scoped>
@import "../assets/css/main.css";
.right .steps {
  display: flex;
  align-items: center;
  height: 60px;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(231, 231, 231, 1);
  margin-bottom: 20px;
}
.right .steps p {
  font-size: 16px;
  /*color:rgba(39,39,39,1);*/
  margin-right: 15px;
}
.right .steps .home {
  width: 30px;
  height: 30px;
  margin-right: 15px;
}
.right .steps .arrow {
  width: 12px;
  height: 12px;
  margin-right: 15px;
}
</style>
